export default {
    "unit": {
        stepSize: 1,
        round: qty => qty
    },
    "tonne": {
        stepSize: 0.1,
        round: qty => Math.round(qty * 100) / 100
    },
    "sack": {
        stepSize: 1,
        round: qty => Math.ceil(qty)
    },
    "truck": {
        stepSize: 1,
        round: qty => Math.ceil(qty)
    }
}